import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
export default {
  mixins: [popUp],
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        match_id: "",
        home_score: "",
        away_score: ""
      },
      home_name: '',
      away_name: '',
      subLoading: false,
      rules: {
        home_score: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        away_score: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }]
      }
    };
  },
  computed: {},
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.tournament_id = sessionStorage.getItem('coachId');

                if (data) {
                  _this.copyPrimitive();

                  _this.formData.match_id = data.id;
                  _this.home_name = data.home_team_name;
                  _this.away_name = data.away_team_name;
                  _this.formData.home_score = data.home_score;
                  _this.formData.away_score = data.away_score;

                  _this.copyData();
                }

                _this.dialogFormVisible = true;

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    rewriteClearData: function rewriteClearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.clearData(isClear);
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$refs.ruleForm.validate(function (valid) {
                  if (valid) {
                    _this2.subLoading = true;
                    var data = JSON.parse(JSON.stringify(_this2.formData));

                    _this2.$api.submitResult(data).then(function (res) {
                      if (res.code == 200) {
                        _this2.$message.success(res.msg);

                        _this2.$emit('change');

                        _this2.dialogFormVisible = false;
                      } else {
                        _this2.$message.error(res.msg);
                      }

                      _this2.subLoading = false;
                    }).catch(function (err) {
                      _this2.subLoading = false;

                      _this2.$message.error(err.msg);
                    });
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};